import { render, staticRenderFns } from "./IconCurrencyEuroSolid.vue?vue&type=template&id=045b7440"
import script from "./IconCurrencyEuroSolid.vue?vue&type=script&lang=js"
export * from "./IconCurrencyEuroSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports